<template>
  <div class="line-chart-modal1" ref="lineChartModalRef">

    <artmisads-modal
      :open="true"
      :title="props.title"
      :width="1200"
      :getContainer="() => lineChartModalRef"
      :destroyOnClose="true"
      :maskClosable="false"
      :footer="null"
      :onCancel="props.onCancleModal"
    >
    <div class="filterBar">
    
      <div class="filterBar-content">
        <div class="brand">
          <span>{{ showTrackingIdType==='PRIMARY' ? props.itemInfo.primaryTrackingId : props.itemInfo.subTrackingId }}</span>
          <a href="javascript:void(0)" style="margin-left: 30px;" >{{ showTrackingIdType==='PRIMARY' ? 'Primary Id' : 'Sub Id' }}</a>
        </div>
        <div class="radio">
          <a-radio-group @change="handlePromotionTypeChange" v-model:value="promotionType"
              :style="{ marginLeft: '8px' }">
              <a-radio-button value="product">Product</a-radio-button>
              <a-radio-button value="brand">Brand</a-radio-button>
            </a-radio-group>
        </div>
        <div class="date">
        <!-- <span>Date Range</span> -->
        <artemisads-range-picker :allowClear="false" :value="hackValue || dateParams" 
          :presets="RANGE_PRESETS" :disabled-date="disabledDate" @change="onChangeDate" @openChange="onOpenChange"
          @calendarChange="onCalendarChange" />
        </div>
       
      </div>
    </div>
    <a-spin :spinning="props.loading">
    <div class="table">
      <artmisads-table
        :columns="columns"
        row-key="id"
        :data-source="props.dataList"
        :scroll="{x: 1000}"
        :pagination="{
          total: props.tableTotal,
          current: props.params.page,
          pageSize: props.params.size,
          showSizeChanger: true
        }"
        :change="onChangePage"
        rowClassName="table-item"
        table-layout="fixed"
      >
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.name === 'showCurrency'">
            {{text ? AMAZON_CURRENCY_MAPPER[props.marketplace] : ''}}{{text}}
          </template>
          <template v-if="column.name === 'conversionsRate'&&!record.children">
            {{ text ? (text * 100).toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1') + '%' : '0' }}
          </template>
        </template>
      </artmisads-table>
    </div>
    </a-spin>

  </artmisads-modal>
  </div>
</template>

<script setup lang="jsx">
import { ref,computed } from 'vue';
import { AMAZON_CURRENCY_MAPPER } from '~/contants/common';
import { RANGE_PRESETS } from '~/contants/reports'
import moment from 'moment'
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: 'Tracking ID Report Detail'
  },
  dataList: {
    type: Array,
    default: () => []
  },
  marketplace: {
    type: String,
    default: 'amazon.com'
  },
  tableTotal: {
    type: Number,
    default: 0
  },
  params: {
    type: Object,
    default: () => ({})
  },
  setParams: {
    type: Function,
    default: () => {}
  },
  onCancleModal: {
    type: Function,
    default: () => {}
  },
  itemInfo: {
    type: Object,
    default: () => ({})
  },
  loading: {
    type: Boolean,
    default: false
  }
});
const dates = ref()
const hackValue = ref()
const disabledDate = current => {
  let notDate = false, tooLate = false, tooEarly = false
  notDate = current.valueOf() > moment().valueOf()
  if (dates.value && dates.value.length) {
    tooEarly = dates.value[1] && dates.value[1].diff(current, 'days') > 365
    tooLate = dates.value[0] && current.diff(dates.value[0], 'days') > 365
  }
  return notDate || tooEarly || tooLate
}

const lineChartModalRef = ref();

const promotionType = ref(props.params.promotionType)

const showTrackingIdType = computed(()=>{
  // console.log(props.itemInfo,'props.itemInfo')
  if(props.itemInfo.primaryTrackingIds){
    return 'PRIMARY'
  }else{
    return 'SUB'
  }
})
const emit = defineEmits(['update:visible', 'cancel']);
const dateParams = ref([moment(props.params.startReportDateTimestamp),moment(props.params.endReportDateTimestamp)])
const onCancel = () => {
  emit('update:visible', false);
  emit('cancel');
};
const columns =ref([
  {
    title: 'Product ASIN',
    dataIndex: 'productAsin',
    width: 200,
    fixed: 'left',
  },
  {
    title: 'DPVs',
    dataIndex: 'detailPageViews',
    width: 80,
    sorter: true,
  },
  {
    title: 'Add to Cart',
    dataIndex: 'addToCart',
    width: 130,
    sorter: true,
  },
  {
    title: 'Conversions',
    dataIndex: 'conversions',
    width: 120,
    sorter: true,
  },
  // {
  //   name: 'conversionsRate',
  //   title: 'Conversions Rate',
  //   dataIndex: 'conversionsRate',
  //   width: 180,
  //   sorter: true,
  // },
  {
    title: 'Sales for Commission',
    dataIndex: 'discountedSalesAmount',
    name: 'showCurrency',
    width: 240,
    sorter: true,
  },
  {
    title: 'Commission',
    dataIndex: 'commissionAmount',
    name: 'showCurrency',
    width: 120,
    sorter: true,
  }
]);
const onChangePage = (data, filters, sorter) => {
  const { current, pageSize } = data;
  let newParams = { ...props.params };
  newParams.page = current;
  newParams.size = pageSize;
  // console.log(sorter,'sorter')
  if (sorter) {
    const { field, order } = sorter;
    newParams.sortField = field;
    newParams.sortDirection = order === 'ascend' ? 'asc' : 'desc';
  } 
  props.setParams(newParams);
};
const onChangeDate=val=>{
  if (val) {
    dateParams.value = val
    const dateTime = {
      startReportDateTimestamp: val[0].valueOf(),
      endReportDateTimestamp: val[1].valueOf(),
    }
    props.setParams(dateTime)
  } else {
    dateParams.value = []
  }
}
const handlePromotionTypeChange=val=>{
  if(val.target.value==='product'){
    columns.value[0]={
    title: 'Product ASIN',
    dataIndex: 'productAsin',
    width: 200,
    fixed: 'left',
  }
  }
  else{
columns.value[0]=columns.value[0]={
    title: 'Brand',
    dataIndex: 'brandName',
    width: 200,
    fixed: 'left',
  }
  }
  props.setParams({
    promotionType:val.target.value,
    page : 1
  })
}
const onCalendarChange = val => {
  dates.value = val
}
const onOpenChange = open => {
  if (open) {
    dates.value = []
    hackValue.value = []
  } else {
    hackValue.value = undefined
  }
}


</script>

<style lang="less" scoped>
.filterBar{
  padding: 0px !important;
  margin-bottom: 16px !important;
}
.filterBar {
  display: flex;
  padding: 0px;
  margin-bottom: 16px;
  .filterBar-content {
    padding: 16px;
    background-color: var(--bg-gray-1);
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-radius: 8px;
  }
}
.marketplace,
.date,
.product,
// .brand,
.trankingId {
  display: flex;
  flex-direction: column;

  >span {
    color: var(--dark-2);
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.3px;
    line-height: 18px;
    margin-bottom: 4px;
  }
}
.radio{
  display: flex;
  align-items: center;
}
.brand{
  display: flex;
  align-items: center;
  >span {
    color: var(--dark-2);
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.3px;
    line-height: 18px;
    // margin-bottom: 4px;
  }
  
}
.table {
  // :deep(.ant-table) {
  //   table {
  //     table-layout: fixed !important;
  //   }
  // }
}
</style> 